import {
    MS_PER_SECOND,
    SECONDS_PER_HOUR,
    SECONDS_PER_MINUTE,
    TIME_FORMAT_PADDING,
    TIME_FORMAT_CHAR,
} from "../constants/time-constants";

export function formatCountdown(ms: number): string {
    const totalSeconds = Math.floor(ms / MS_PER_SECOND);
    const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
    const minutes = Math.floor(
        (totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE
    );
    const seconds = totalSeconds % SECONDS_PER_MINUTE;

    return `${String(hours).padStart(TIME_FORMAT_PADDING, TIME_FORMAT_CHAR)}:${String(minutes).padStart(TIME_FORMAT_PADDING, TIME_FORMAT_CHAR)}:${String(seconds).padStart(TIME_FORMAT_PADDING, TIME_FORMAT_CHAR)}`;
}
